import Parameter from '../Parameter';

export default class CheckBoxField extends Parameter {
    /**
     * Constructeur CheckBox
     * @param Name 
     * @param Label 
     * @param Type 
     * @param EmptyText 
     * @param Selected 
     * @param Option 
     * @param Listeners 
     * @param Value Extends
     */
    constructor(Name: string = '', Label: string = '', Type: string = 'CheckBox', EmptyText: string = '', Selected: string = '', Option: object = {}, Listeners: Array<{ key: string; value: string }> = []) {
        super(Name, Label, Type, EmptyText, Selected, Option, Listeners);
    }

    //#region Methode Static

    // Enregistre la sous-class dans la class Parent
    static {
        Parameter.registerSubclass(CheckBoxField); 
    }

    //#endregion

    /**
     * CheckBox à toujours des données
     * @returns true
     */
    override HasValue(): boolean {
        return true;
    }

    /**
     * Propriété filtrées pour la création d'un objet CheckBox
     * @returns Dictionnaires Nom / Valeurs
     */
    override getProperties(): Array<[string, any]>{
        return Object.entries(this).filter(([key]) => 
            this.keysToFilter.includes(key) )
    }

    // Créations des clé pour filtrer les propriété de CheckBox
    override keysToFilter: string[] =  ['Label', 'Selected'];

    override create() : CheckBoxField{
        return new CheckBoxField(this.Name, this.Label, this.Type, this.EmptyText, this.Selected, this.Option, this.Listeners);
    }
}